module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/@qtt/ewx-login-sdk/~/axios/index.js
// module id = 163
// module chunks = 24